export default __webpack_public_path__ + "static/media/funds.e5f43a27.jpeg";